import { createGenericDispatcher } from '../action-dispatcher-factory';

import Job from '../../api/job-api-client';

export const addApplicant = (jobId: number, applicant: NewManualApplicant) =>
  createGenericDispatcher<{ application: FullApplicant; existing: boolean }>({
    name: 'ADD_APPLICANT',
    loadFunction: () => new Job(jobId).manuallyAddApplicant(applicant),
    args: { jobId },
  });
